var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Caption from "../Caption";
import { transparentize } from 'polished';
import React from 'react';
import ReactSelect from 'react-select';
import theme from "../../styles/theme";
import { css, styled } from "../../utils";
var colors = theme.colors, font = theme.font;
var fontStyle = {
    fontSize: font.size.large,
    fontFamily: font.family.proximaNova,
    letterSpacing: '0.08rem',
    color: colors.lighterBlack,
};
var customStyles = {
    control: function (provided, _a) {
        var menuIsOpen = _a.menuIsOpen, hasValue = _a.hasValue;
        return (__assign(__assign(__assign({}, provided), fontStyle), { height: 56, borderRadius: 5, borderColor: menuIsOpen || hasValue ? colors.primary : colors.gray2, boxShadow: menuIsOpen || hasValue ? "0 0 0 1px " + colors.primary : 'none', borderWidth: 2, ':hover': {
                cursor: 'pointer',
                borderColor: colors.primary,
                boxShadow: "0 0 0 1px " + colors.primary,
            } }));
    },
    indicatorSeparator: function () { return ({
        display: 'none',
    }); },
    menu: function (provided) { return (__assign(__assign({}, provided), { margin: "2px 0", boxShadow: "0 0 7px 0 " + transparentize(0.85, colors.black) })); },
    menuList: function (provided) { return (__assign(__assign({}, provided), { borderRadius: 5, padding: 0 })); },
    option: function (provided, _a) {
        var isSelected = _a.isSelected;
        return (__assign(__assign(__assign({}, provided), fontStyle), { padding: '0.5rem 1rem', color: isSelected ? colors.white : colors.lighterBlack, ':hover': {
                cursor: 'pointer',
            } }));
    },
    input: function (provided) { return (__assign(__assign({}, provided), fontStyle)); },
};
var Extra = styled(Caption)(function (_a) {
    var font = _a.theme.font;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-weight: ", ";\n    letter-spacing: normal;\n    margin-top: 0.5rem;\n  "], ["\n    font-weight: ", ";\n    letter-spacing: normal;\n    margin-top: 0.5rem;\n  "])), font.weight.normal);
});
var Container = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 2rem;\n"], ["\n  margin-bottom: 2rem;\n"])));
var Select = function (_a) {
    var extra = _a.extra, props = __rest(_a, ["extra"]);
    return (React.createElement(Container, null,
        React.createElement(ReactSelect, __assign({ styles: customStyles, theme: function (theme) { return (__assign(__assign({}, theme), { colors: __assign(__assign({}, theme.colors), { primary: colors.primary, primary25: colors.lightGray }) })); } }, props)),
        extra && React.createElement(Extra, { light: true }, extra)));
};
export default Select;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Select.js.map